/**
 * ПОЛНЫЙ ПУТЬ: D:\QR\QR-WEB\dashboard\src\components\Layout\UserLayout.jsx
 * ВЕРСИЯ: 4.0.0 - v5.0 Brand Only
 * ОБНОВЛЕНО: 21.01.2026
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NotificationBell from '../Notifications/NotificationBell';
import '../styles/UserLayout.css';

export const UserLayout = ({ children, user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('userToken');
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userRole');
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className="user-layout">
      <nav className="user-navbar">
        <div className="user-navbar-container">
          <div className="user-navbar-logo" onClick={() => navigate('/dashboard')} style={{cursor: 'pointer'}}>
            <span className="user-logo-icon">🎁</span>
            <div className="user-logo-block">
              <span className="user-logo-text">DARY</span>
              <span className="user-logo-tagline">Digital Asset Reward Yours</span>
            </div>
          </div>

          <div className="user-navbar-menu">
            <button
              className={'user-nav-btn ' + (isActive('/dashboard') ? 'active' : '')}
              onClick={() => navigate('/dashboard')}
            >
              🏠 Главная
            </button>

            <button
              className={'user-nav-btn ' + (isActive('/vouchers/claim') ? 'active' : '')}
              onClick={() => navigate('/vouchers/claim')}
            >
              📥 Получить
            </button>

            <button
              className={'user-nav-btn ' + (isActive('/vouchers/my') ? 'active' : '')}
              onClick={() => navigate('/vouchers/my')}
            >
              🎁 Подарки
            </button>

            <button
              className={'user-nav-btn ' + (isActive('/brand-store') ? 'active' : '')}
              onClick={() => navigate('/brand-store')}
            >
              🏪 Brand Store
            </button>

            <button
              className={'user-nav-btn ' + (isActive('/my-promocodes') ? 'active' : '')}
              onClick={() => navigate('/my-promocodes')}
            >
              🎟️ Промокоды
            </button>

            <button
              className={'user-nav-btn ' + (isActive('/profile') ? 'active' : '')}
              onClick={() => navigate('/profile')}
            >
              👤 Профиль
            </button>
          </div>

          <div className="user-navbar-user">
            <NotificationBell />
            <div className="user-avatar">
              {user?.email?.charAt(0).toUpperCase() || 'U'}
            </div>
            <span className="user-email">{user?.email || 'User'}</span>
            <button
              className="user-logout-btn"
              onClick={handleLogout}
              title="Выход"
            >
              🚪
            </button>
          </div>
        </div>
      </nav>

      <main className="user-main-content">
        <div className="user-content-wrapper">
          {children}
        </div>
      </main>

      <footer className="user-app-footer">
        <p>🎁 DARY © 2026 | Digital Asset Reward Yours</p>
      </footer>
    </div>
  );
};

export default UserLayout;